module.exports = __webpack_public_path__ + "media/images/main_visual_barbecue_guide-c3dbd7e3e618e882071ad5526841f9db.png";